<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          name='Dashboard'
          icon='fas fa-th-large c-lightblue'
          path='/dashboard'
        >
        </sidebar-item>
                <sidebar-item
          name='Chefs'
          icon='fas fa-utensils c-purple'
          path='/chefs'
        >
        </sidebar-item>
        <sidebar-item
          name='Recipes'
          icon='fas fa-utensils c-orange'
          path='/recipes'
        >
        </sidebar-item>
        <hr class="my-3">
        <sidebar-item
          name='Tags'
          icon='fas fa-tag c-yellow'
          path='/tags'
        >
        </sidebar-item>
        <sidebar-item
          name='Collections'
          icon='ni ni-books c-green'
          path='/collections'
        >
        </sidebar-item>
        <sidebar-item
          name='Brands'
          icon='ni ni-shop c-lightblue'
          path='/brands'
        >
        </sidebar-item>
        <sidebar-item
          name='Operators'
          icon='fas fa-book c-lightblue'
          path='/operators'
        >
        </sidebar-item>
        
        <hr class="my-3">

        <sidebar-item
          name='My Collections'
          icon='fas fa-utensils c-lightblue'
          path='/my-collections'
        >
        </sidebar-item>
        <sidebar-item
          name='My Recipes'
          icon='fas fa-utensils c-lightblue'
          path='/my-recipes'
        >
        </sidebar-item>
        <sidebar-item
          name='Shared'
          icon='fas fa-share-square c-green'
          path='/shared'
        >
        </sidebar-item>
        <sidebar-item
          name='Requests'
          icon='fas fa-edit c-purple'
          path='/requests'
        >
        </sidebar-item>
        <sidebar-item
          name='History'
          icon='fas fa-edit c-purple'
          path='/history'
        >
        </sidebar-item>

        <hr class="my-3">

        <!-- <hr class="my-3" /> -->
      </template>

      <template slot="links-after">
        <li class="nav-item nav-item">
          <div class="align-items-center">
          <a href=" " :title="`Version: ` + this.appVersion">
            <img class="footer-whipstir-logo" src="/img/whipstir/Whipstir-logo-sm.gif" onerror="this.src=/img/whipstir/Whipstir-logo-sm.gif';" />
          </a>
        </div>
        </li>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import DashboardContent from './Content.vue';
import { FadeTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    DashboardContent,
    FadeTransition,
  },
  computed: {
    isAdmin() {
      return this.$store.getters.userIsAdmin
    },
    menuFirst() {
      return this.$store.state.sidebarLinks.menu_first;
    },
    menuSecond() {
      return this.$store.state.sidebarLinks.menu_second;
    },
    menuThird() {
      return this.$store.state.sidebarLinks.menu_third;
    },
    appVersion() {
      return 8.1;
      var user = JSON.parse(localStorage.getItem('user'));
      return user.version;
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
    resizeFooterLogo(e) {
      let navHeader = document.querySelector('.sidenav-header');
      let navHeaderHeight = navHeader.offsetHeight;
      let navInner = document.querySelector('.navbar-nav');
      let navInnerHeight = navInner.offsetHeight;
      let windowHeight = window.innerHeight;

      let navTotalHeight = eval( windowHeight - (navHeaderHeight+navInnerHeight) );
      let footerLogo = document.querySelector('.footer-whipstir-logo');
      let footerLogoMargin = eval(navTotalHeight-140);
      if ( footerLogoMargin < 0 ) {
        footerLogoMargin = 0;
      }
      footerLogo.style.marginTop = footerLogoMargin+'px';
      // console.log('Footer position: ', windowHeight, navHeaderHeight, navInnerHeight, footerLogoPosition);
    }
  },
  created() {
    window.addEventListener("resize", this.resizeFooterLogo);
    
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeFooterLogo);
  },
  mounted() {
    this.initScrollbar();
    this.resizeFooterLogo();
  },
};
</script>
<style lang="scss">
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link { padding: .2rem .675rem; }
.footer-whipstir-logo { 
    display:block; margin-right:auto; margin-left:auto; width:50%;
    transition: margin-top .2s linear 0s;
}
</style>
